export default "__VITE_ASSET__1b02b0e6__"